// Swiper cho banner trong content-1 (tab Minh Tôn Chuyển Thế)
let f3Swiper = null;

function initFrame3Swiper() {
	// Swiper nạp từ CDN libraryMainsite, có thể tới sau bundle -> chờ rồi init
	if (typeof Swiper === 'undefined') {
		return setTimeout(initFrame3Swiper, 100);
	}
	if (!document.querySelector('.f3-swiper')) return;

	f3Swiper = new Swiper('.f3-swiper', {
		loop: true,
		speed: 500,
		autoplay: { delay: 3500, disableOnInteraction: false },
		pagination: {
			el: '.content-1 .swiper-pagination',
			clickable: true,
			bulletClass: 'f3-bullet MS__sprite-paging',
			bulletActiveClass: 'MS__sprite-paging-act',
		},
	});
}

// Chuyển tab: tab thứ i hiện panel .content-(i+1), ẩn các panel còn lại
function initFrame3Tabs() {
	const tabs = document.querySelectorAll('#Frame3 .f3-tab');
	const panels = document.querySelectorAll('#Frame3 .content-1, #Frame3 .content-2, #Frame3 .content-3');
	if (!tabs.length || !panels.length) return;

	tabs.forEach((tab, i) => {
		tab.addEventListener('click', (e) => {
			e.preventDefault();

			tabs.forEach((t) => t.classList.remove('active'));
			panels.forEach((p) => p.classList.remove('active'));
			tab.classList.add('active');
			if (panels[i]) panels[i].classList.add('active');

			// Swiper tính sai kích thước khi bị ẩn -> update lại khi quay về content-1
			if (i === 0 && f3Swiper) f3Swiper.update();
		});
	});
}

// Dot điều hướng event-list (mobile): tạo dot theo đúng số event, click cuộn tới event đó
function initFrame3EventNav() {
	const list = document.querySelector('#Frame3 .event-list');
	const paging = document.querySelector('#Frame3 .event-paging');
	if (!list || !paging) return;

	const events = Array.prototype.slice.call(list.children);
	if (events.length < 2) return; // 1 event thì không cần dot

	const ACTIVE = 'MS__sprite-paging-act';

	// Sinh dot theo số event
	paging.innerHTML = '';
	const dots = events.map((ev, i) => {
		const dot = document.createElement('span');
		dot.className = 'event-dot MS__sprite-paging' + (i === 0 ? ' ' + ACTIVE : '');
		dot.addEventListener('click', () => {
			list.scrollTo({ left: ev.offsetLeft - events[0].offsetLeft, behavior: 'smooth' });
		});
		paging.appendChild(dot);
		return dot;
	});

	const setActive = (i) => dots.forEach((d, k) => d.classList.toggle(ACTIVE, k === i));

	// Cuộn tay -> dot active là event gần mép trái nhất
	list.addEventListener('scroll', () => {
		const x = list.scrollLeft + events[0].offsetLeft;
		let nearest = 0;
		let min = Infinity;
		events.forEach((ev, i) => {
			const d = Math.abs(ev.offsetLeft - x);
			if (d < min) {
				min = d;
				nearest = i;
			}
		});
		setActive(nearest);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initFrame3Swiper();
	initFrame3Tabs();
	initFrame3EventNav();
});
